// Types
import User from '@/types/user';

// Utils
import localStorageUtils from '@/utils/local-storage';

export enum PERSISTENCE_KEYS {
  EXISTING_CLIENT_CONTACT = 'EXISTING_CLIENT_CONTACT',
  EXISTING_CLIENT_PORTFOLIO = 'EXISTING_CLIENT_PORTFOLIO',
  EXISTING_CLIENT_OMNI_RISK_PROFILE = 'EXISTING_CLIENT_OMNI_RISK_PROFILE',
}

/**
 * Resets the local storage persistence source for the given user.
 * @param storageKey
 * @param user
 * @param refetchData - A callback function to refetch data after resetting the persistence source.
 */
export const resetLocalStoragePersistenceSource = (storageKey: string, user: User, refetchData?: () => void): void => {
  if (localStorageUtils.getPersistenceSource(user, storageKey)) {
    localStorageUtils.setPersistenceSource(user, storageKey, undefined);
    if (refetchData) {
      refetchData();
    }
  }
};

/**
 * Checks if the user has the omni risk profile persistence key enabled in it's config.
 * @param user
 * @returns boolean of whether the user has the omni risk profile persistence key enabled.
 */
export const userHasOmniRiskProfilePersistenceKeyEnabled = (user: User) =>
  user?.appConfig?.persistenceKeys?.includes(PERSISTENCE_KEYS.EXISTING_CLIENT_OMNI_RISK_PROFILE) ?? false;
